import styled, { css } from 'styled-components';
import { media, remCalc, layout } from '@prisjakt/ui-base';
import { Link as LinkComponent } from 'react-router-dom';
import CorePropertiesComponent from '@prisjakt/ui-core-properties';
import CampaignBadgeComponent from '../../../../../../components/campaign-badge';
import LinkToPriceHistory from '../link-to-price-history';

export const DesktopHeader = styled.header`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  margin: ${layout.spacing.xSmall} 0;

  ${media.smallOnly` display: none;`}

  ${media.mediumDown`
    padding-left: ${layout.spacing.xSmall};
    padding-right: ${layout.spacing.xSmall};
  `}
`;

export const ProductSummary = styled.div`
  flex: 0 0 auto;
  width: 300px;
  margin-right: ${layout.spacing.xSmall};

  ${media.mediumDown`
    width: 210px;
  `}
`;

type TitleProps = {
  inner?: boolean;
  outer?: boolean;
  'data-test': string;
};
export const Title = styled.h1<TitleProps>`
  font-size: ${remCalc(22)};
  font-weight: normal;
  margin-bottom: ${layout.spacing.xSmall};

  ${props =>
    props.inner &&
    css`
      margin-right: 20px;
    `}

  ${props =>
    props.outer &&
    css`
      flex: 1 0 auto;
      margin-bottom: ${layout.spacing.xSmall};
      margin-right: 0px;
    `}
`;

export const More = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ProductActions = styled.div`
  margin: 10px 0 20px 0;
`;

export const Content = styled.div`
  flex: 1 1;
  justify-content: space-between;
  padding-right: ${layout.spacing.xSmall};
  padding-left: ${layout.spacing.xSmall};
  min-width: 0;
`;

export const Media = styled.div`
  position: relative;
  margin-right: ${layout.spacing.small};
  margin-left: ${layout.spacing.xSmall};
`;

export const StoreLogo = styled(LinkComponent)`
  position: absolute;
  text-align: center;
  bottom: calc(100% + 2px);
  right: 10px;

  img {
    max-width: 88px;
  }
`;

export const CategoryRank = styled.div`
  font-size: 14px;
  margin-bottom: ${remCalc(10)};
  color: ${p => p.theme.colors.base600};
`;

export const CategoryRankPill = styled.span`
  font-size: 12px;
  background: ${p => p.theme.pill.primary.bg};
  color: ${p => p.theme.pill.primary.text};
  font-weight: 600;
  text-transform: uppercase;
  padding: 2px 4px;
  border-radius: 2px;
  margin-bottom: 2px;
`;

export const CategoryRankNumber = styled.span`
  color: ${p => p.theme.pill.primary.text};
`;

export const RatingWrapper = styled.div`
  margin-bottom: ${remCalc(10)};
  text-decoration: underline;
  color: ${p => p.theme.text.callToAction};

  span {
    color: inherit;
  }
  &:hover span {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const DisplayProperties = styled(CorePropertiesComponent)`
  margin: 0 0 ${layout.spacing.xSmall};
`;

export const ReviewBadges = styled.div`
  margin: 0 0 ${layout.spacing.xSmall};
`;

export const Link = styled(LinkComponent)`
  color: ${p => p.theme.colors.maybeBlue700};
  cursor: pointer;
  outline: none;

  &:hover,
  &:focus {
    color: ${p => p.theme.colors.maybeBlue500};
    text-decoration: underline;
  }
`;

export const RankContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  > :not(:last-child) {
    margin-right: ${layout.spacing.xSmall};
  }
`;

export const CampaignBadge = styled(CampaignBadgeComponent)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const TabletTitle = styled.div`
  display: none;

  ${media.mediumDown`
    display: block;
  `}
`;

export const DesktopTitle = styled.div`
  display: none;

  ${media.largeUp`
    display: block;
  `}
`;

export const PriceHistoryLink = styled(LinkToPriceHistory)`
  display: none;

  ${media.largeUp`
      display: block;
    `}
`;
